export default __webpack_public_path__ + "static/media/img8.61f8171d.jpg";